import {FC} from 'react'
import {settings} from "../../../constants/global";
import Manual from "../../Car/Manual";
import Button from "../Button/Button";

interface Props {
    booking:Booking,
    setBooking:Function
}

const Modal: FC<Props> = ({ booking, setBooking}) => {

    let title = 'Information'
    let content = ''
    let visible = false
    let layout = 'default'

    switch (booking.modal) {
        case 1:
            content = 'Du kan bara lägga till ett tillval i kategorin <span className="product_cat_name">Bilvård</span>.<br/>Ta bort ett tillval och försök igen.'
            visible = true
            break
        case 2:
            content = settings.auth.message
            visible = true
            break
        case 3:
            content = 'Ogiltigt registreringsnummer.<br/>Om du t.ex. har en utländsk bil, var vänlig skriv till oss på <a href="mailto:info@mechanum.com">info@mechanum.com</a> för att boka ditt besök.'
            visible = true
            break
        case 4:
            content = 'Hämtning av bildata misslyckade.<br/>Var god ange ditt bilmärke, modell och årsmodell.'
            visible = true
            break
        case 5:
            // Opens tire shop modal components/common/TireShop/Tireshop.tsx
            break
        case 6:
            content = 'Tyvärr är tiden inte längre tillgänglig.<br/>Var god välj en annan tid.'
            visible = true
            break
        case 7:
            layout = 'tooltip'
            content = 'Du måste ange mätarställning för att kunna gå vidare.'
            visible = true
            break
        case 8:
            layout = 'tooltip'
            content = 'Du måste fylla i fältet: "Beskriv vad som skall åtgärdas".'
            window.scrollTo(0, document.body.scrollHeight);
            visible = true
            break
        case 9:
            layout = 'tooltip'
            content = 'Välj först datum och tid.'
            visible = true
            break
        case 10:
            layout = 'tooltip'
            content = 'Välj ett inlämningsalternativ för att gå vidare.'
            visible = true
            break
        case 11:
            layout = 'tooltip'
            content = 'Välj lånebil för att gå vidare.'
            visible = true
            break
        case 12:
            layout = 'tooltip'
            content = 'Fyll i förnamn, efternamn, telefon och en korrekt e-postadress.'
            visible = true
            break
        case 13:
            content = booking.modal_message
            visible = true
            break
        case 14:
            layout = 'tooltip'
            content = 'Välj om du vill bli kontaktad om serviceavtal för att gå vidare.'
            visible = true
            break
    }

    const handleClose = function () {
        booking.modal = 0
        setBooking({
            ...booking,
        })
    }

    if(!visible)
        return


    // Mandatory fields for manual car popup
    let enableClose = true
    if (booking.modal === 4) {
        enableClose = false
        if (booking.car.model && booking.car.year.length>3 && booking.car.model)
            enableClose = true
    }

    return (
        <>
            {layout === 'default' ? (
                <>
                    <div id="modal-blur"/>
                    <div id="wco-booking-popup" className="wco-booking-popup active">
                        {booking.modal !== 4 && (<i className="popup_close far fa-times" aria-hidden="true" onClick={() => handleClose()} />)}
                        <div className="wco-booking-popup_title">
                            <h2>{title}</h2>
                        </div>
                        <div className="wco-booking-popup_content">
                            <div className="wco-booking-popup_message" dangerouslySetInnerHTML={{__html: content}} />
                            {booking.modal === 4 && (<Manual setBooking={setBooking} booking={booking}/>)}
                            <Button id={'btn-modal-ok'} className={'btn-booking-next btn btn-center btn--skyblue'} title={'Ok'} action={handleClose} active={enableClose} />
                        </div>
                    </div>
                </>
                ):(
                    <>
                        <div id="wco-booking-popup" className="wco-booking-popup active tooltip">
                        <div className={'tooltip'}>
                            {booking.modal !== 4 && (<i className="popup_close far fa-times-circle" aria-hidden="true" onClick={() => handleClose()} />)}
                            <div className="wco-booking-popup_message" dangerouslySetInnerHTML={{__html: content}} />
                        </div>
                        </div>
                    </>
            )}

        </>
    )
};

export default Modal
